import React, { useEffect } from 'react';
import PropTypes from 'prop-types';
import { sendMobileErrorNotification, sendMobileLoadedNotification } from '@ecs-uk/web-common-mobile-view-helpers';
import MySubscriptionPage from '../../my-subscription';

const MobileMySubscriptionPage = ({ isBlockedByKillSwitch = false }) => {
  useEffect(() => {
    if (isBlockedByKillSwitch) {
      sendMobileErrorNotification();
    } else {
      sendMobileLoadedNotification();
    }
  }, [isBlockedByKillSwitch]);

  if (isBlockedByKillSwitch) {
    return null;
  }

  return <MySubscriptionPage isWebview />;
};

MobileMySubscriptionPage.propTypes = {
  isBlockedByKillSwitch: PropTypes.bool,
};

export default MobileMySubscriptionPage;
